  import React, { useState, useEffect } from "react"
import { Card, CardBody, Row, Col, Button } from "reactstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactBSAlert from "react-bootstrap-sweetalert"
import ReactTable from 'react-table-6'
import 'react-table-6/react-table.css'
import { FaEdit, FaTrashAlt, FaToggleOff } from "react-icons/fa";
import { deleteDoctor } from '../../doctorapi'
import "react-toastify/dist/ReactToastify.css"
import { toast } from "react-toastify"
import { ButtonsWrap } from './styles.js'
import matchSorter from 'match-sorter'

const Doctorlist = ({ getAllData, setGetAllData, handleedit, toggle }) => {
  const [getDoctorValue, setGetDoctorValue] = useState([])
  const [alertMessage, setAlertMessage] = useState(null)
  const [deleteValue, setdeleteValue] = useState()
  toast.configure()
  useEffect(() => {
    setGetDoctorValue(
      getAllData &&
      getAllData.length &&
      getAllData.map((prop, key) => {
        return {
          id: prop._id,
          email: prop.email,
          firstName: prop.firstName,
          lastName: prop.lastName,
          Address: prop.Address,
          zip: prop.zip
        }
      })
    )
  }, [])

  const warningWithConfirmMessage = (row, type) => {
    setAlertMessage(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "0px" }}
        title="Are you sure?"
        onConfirm={() => successDelete(row.original, type)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText={
          type == "activate" ? "Yes, Activate it!" : "Yes, Inactive it!"
        }
        cancelBtnText="Cancel"
        showCancel
        className="sweet-btn"
      >
      </ReactBSAlert>
    )
  }
  const successDelete = (row, type) => {
    setAlertMessage(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "0px" }}
        title={type == "activate" ? "Activated!" : "Inactivated!"}
        onConfirm={() => hideAlert(row, type)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
      >
        {type == "activate" ? "Activated!" : "Inactivated!"}
      </ReactBSAlert>
    )
  }
  const hideAlert = (row, type) => {
    if (row) {
      row.isDeleted = type == "activate" ? false : true
      deleteDoctor(row).then(response => {
        if (response.data.statusCode == 200) {
          let data = getAllData.findIndex(
            item => item._id === response.data.body.data
          )
          if (data > -1) {
            let newdata = getAllData
            newdata.splice(data, 1, response.data.body)
            setGetAllData([...newdata])
            notify("success")
          }
        } else {

        }
      }).catch(error => {
        notify("error")
      })

    }
    setAlertMessage(null)
  }
  const editHandle = (row) => {
    handleedit(row)
    toggle()

  }
  const notify = msg => {
    if (msg == "error") {
      toast.error("Internal Server Error")
    } else if (msg == "success") {
      toast.success("Doctor Delete Successfully")
    }
  }
  return (
    <div className="content">
      {alertMessage}
      {getAllData && getAllData.length > 0 ? (
        <ReactTable
          data={getAllData}
          filterable
          columns={[
            {
              Header: "First Name",
              id: "firstName",
              accessor: d => d.firstName,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["firstName"] }),
              filterAll: true
            },
            {
              Header: "Last Name",
              id: "lastName",
              accessor: d => d.lastName,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["lastName"] }),
              filterAll: true
            },
            {
              Header: "Email",
              id: "email",
              accessor: d => d.email,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["email"] }),
              filterAll: true
            },
            {
              Header: "Address",
              id: "Address",
              accessor: d => d.Address,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["Address"] }),
              filterAll: true
            },
            {
              Header: "Zipcode",
              id: "zip",
              accessor: d => d.zip,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["zip"] }),
              filterAll: true
            },
            {
              Header: "Products",
              id: "productTypes",
              accessor: d=> d.productTypes,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["productTypes"] }),
              Cell: props => <span className='number'>{props.value.join(', ')}</span>,
              filterAll: true
            },
            {
              Header: () => (
                <span>
                  Action
                        </span>
              ),
              accessor: 'edit',
              Cell: (row) => (
                <div style={{ display: 'flex', }}>
                  <div>
                  </div>
                  <ButtonsWrap className="actions-right">
                    <Button
                      className="activate"
                      onClick={() => {
                        warningWithConfirmMessage({ ...row, isDeleted: false }, "activate")
                      }}
                      disabled={row.original.isDeleted ? false : true}
                    >
                      <p>activate</p>
                    </Button>
                    <Button
                      className="inActivate"
                      onClick={() => {
                        warningWithConfirmMessage({ ...row, isDeleted: true }, "deactivate")
                      }}
                      disabled={row.original.isDeleted ? true : false}
                    >
                      <p>inactivate</p>
                    </Button>
                  </ButtonsWrap>
                  <Button
                    style={{ margin: "0px 10px" }}
                    className="btn-icon"
                    color="warning"
                    size="sm"
                    className="action-button"
                    onClick={() => {
                      editHandle(row)
                    }}
                  >
                    <FaEdit style={{ FontSize: "20px" }} />
                  </Button>
                </div>
              ),
              status: (row) => (
                <div>
                  {row.original.isDeleted ? (
                    <p style={{ color: "red" }}>Inactive</p>
                  ) : (
                      <p style={{ color: "green" }}>Active</p>
                    )}
                </div>
              ),
            }
          ]}
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value}
          defaultPageSize={10}
          showPaginationTop
          showPaginationBottom={false}
          className="-striped -highlight primary-pagination"
        />
      ) : (
          <p>No Data Found</p>
        )}
    </div>
  )
}

export default Doctorlist



// WEBPACK FOOTER //
// ./src/component/Doctorlist/index.js